// components/ui/LoadingErrorState.tsx
import React from 'react';

interface LoadingErrorStateProps {
  isLoading: boolean;
  isError: boolean;
  errorMessage?: string;
  /** type of skeleton: 'grid' for cards, 'table' for table rows */
  type?: 'grid' | 'table';
  /** number of skeleton items to show */
  count?: number;
}

const LoadingErrorState: React.FC<LoadingErrorStateProps> = ({
  isLoading,
  isError,
  errorMessage,
  type = '',
  count = 6,
}) => {
  if (isLoading) {
    if (type === 'grid') {
      return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {Array.from({ length: count }).map((_, idx) => (
            <div
              key={idx}
              className="animate-pulse bg-gray-200 h-48 rounded-lg"
            />
          ))}
        </div>
      );
    }

      if (type === 'table') {
      return (
        <div className="space-y-4 w-full">
          {Array.from({ length: count }).map((_, idx) => (
            <div
              key={idx}
              className="animate-pulse grid grid-cols-4 gap-4 p-2 bg-gray-200 rounded w-full h-[60px] items-center"
            >
              <div className="h-8 bg-gray-300 rounded w-full" />
              <div className="h-8 bg-gray-300 rounded w-full" />
              <div className="h-8 bg-gray-300 rounded w-full" />
              <div className="h-8 bg-gray-300 rounded w-full" />
            </div>
          ))}
        </div>
      );
    }


    // default spinner fallback
    return (
      <div className="flex items-center justify-center py-8">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex items-center justify-center bg-danger/10 text-danger border border-danger/30 rounded-lg p-4">
        <svg
          className="w-5 h-5 mr-2"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v2m0 4h.01M4.93 4.93l14.14 14.14M12 2a10 10 0 100 20 10 10 0 000-20z"
          />
        </svg>
        <span>{errorMessage || 'Something went wrong.'}</span>
      </div>
    );
  }

  return null;
};

export default LoadingErrorState;
